// extracted by mini-css-extract-plugin
export default {"container":"styles_container__VSB55","icon":"styles_icon__nN0Sc"};